import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export interface GSTRetrofit {
  id: number;
  status: "pending" | "processing" | "completed" | "failed";
  initiated_by: { id: number; name: string } | null;
  old_bill_address_id: number | null;
  new_bill_address_id: number | null;
  po_statuses: Record<string, string>;
  error_message: string;
  created_at: string | null;
  modified_at: string | null;
}

export interface LeadLogEntry {
  id: number;
  status: string;
  remark: string | null;
  updated_by: { id: number; name: string } | null;
  created_at: string | null;
}

export interface ZohoCallEntry {
  id: number;
  log_type: string;
  action: string | null;
  response_type: "success" | "failure" | "";
  po_id: number | null;
  leg_id: string | null;
  created_at: string | null;
}

export interface EstimateActivity {
  estimate: {
    id: number;
    lead_id: string;
    estimate_status: string;
    client_gst: string | null;
    bill_address_id: number | null;
  };
  retrofits: GSTRetrofit[];
  lead_logs: LeadLogEntry[];
  zoho_calls: ZohoCallEntry[];
}

export interface ZohoReconcileResult {
  in_sync: boolean | null;
  estimate_gst: string | null;
  zoho_customer_id: string | null;
  zoho_gst: string | null;
  zoho_contact_name?: string | null;
  reason?: string;
  error?: string;
}

export const fetchEstimateActivity = (params: { estimate_id?: number | string; lead_id?: string }) =>
  axios.get<EstimateActivity>(`${API}/estimate-gst-retrofit-activity/`, { params }).then((r) => r.data);

export const retryGSTRetrofit = (retrofitId: number) =>
  axios
    .post<{ retrofit: GSTRetrofit; cascade_queued: boolean }>(`${API}/gst-retrofit-retry/${retrofitId}/`)
    .then((r) => r.data);

export const reconcileEstimateZoho = (params: { estimate_id?: number | string; lead_id?: string }) =>
  axios.get<ZohoReconcileResult>(`${API}/estimate-zoho-reconcile/`, { params }).then((r) => r.data);
